export default __webpack_public_path__ + "static/media/img-step-a-bg-3.e771df64.jpg";